import { ACCOUNTING_URL } from "../../../services/common-urls";
import { HttpLib } from "../../../services/http/http-lib";
import * as querystring from 'qs';
import { LABEL_URL, BELIEVE_CONTROLLER_URL, DISTRIBUTION_URL, MODIFICATION_URL } from "@/services/common-urls";
import { MHTTPCL, JSON_STRING } from "@/services/http/http-client";
import { createHttpGetOptions } from "../../../services/http/http-client";

export const recoupableService = {

  recoupablesTab: () => MHTTPCL.post(LABEL_URL, {
    section: "royalty",
    action: "recoupables_tab",
    output: JSON_STRING
  }),

  exportCostV2: (
    {
      action = "recoupables_xlsx_export",
      start_date = "",
      end_date = "",
      royalty_account_id = "",
      royalty_period = "",
      cost_groups = [],
      all_groups_selected = 0,
      label_id = "",
      release_id = "",
      invoice_id = "",
      status = [],
      balance_date = "",
      id_prod = "",
      company_code = "",
      validation = "",
      release_identifier = "",
      deal_type_ids = "",
    }
  ) => MHTTPCL.get(LABEL_URL, {
    start_date: start_date,
    end_date: end_date,
    royalty_account_id: royalty_account_id,
    royalty_period: royalty_period,
    cost_groups: JSON.stringify(cost_groups),
    all_groups_selected: all_groups_selected,
    label_id: label_id,
    release_id: release_id,
    invoice_id: invoice_id,
    status: JSON.stringify(status),
    balance_date: balance_date,
    id_prod: id_prod,
    company_code: company_code,
    validation: validation,
    release_identifier: release_identifier,
    deal_type_ids: deal_type_ids,
    section: "royalty",
    action: action
  }, createHttpGetOptions({
    noJsonOutput: true,
    responseType: 'blob'
  })),

  filterCostsV2: (
    {
      action = "filter_costs_v2",
      start_date = "",
      end_date = "",
      royalty_account_id = "",
      royalty_period = "",
      cost_groups = [],
      all_groups_selected = 0,
      label_id = "",
      release_id = "",
      invoice_id = "",
      status = [],
      balance_date = "",
      id_prod = "",
      company_code = "",
      validation = "",
      release_identifier = "",
      deal_type_ids = "",
      start = ""
    }
  ) => MHTTPCL.post(LABEL_URL, {
    start_date: start_date,
    end_date: end_date,
    royalty_account_id: royalty_account_id,
    royalty_period: royalty_period,
    cost_groups: JSON.stringify(cost_groups),
    all_groups_selected: all_groups_selected,
    label_id: label_id,
    release_id: release_id,
    invoice_id: invoice_id,
    status: JSON.stringify(status),
    balance_date: balance_date,
    id_prod: id_prod,
    company_code: company_code,
    validation: validation,
    release_identifier: release_identifier,
    deal_type_ids: deal_type_ids,
    start: start,
    section: "royalty",
    action: action
  }),



  //dropdown search

  searchDropdown: (search, action, label_id = "") => MHTTPCL.get(LABEL_URL, {
    section: 'royalty',
    action: action,
    search: search,
    label_id: label_id
  }),

  searchCosts: (search) => MHTTPCL.get(ACCOUNTING_URL, {
    section: 'costs',
    action: 'search_costs',
    search: search
  }),

  getCost: (cost_split_id) => MHTTPCL.post(LABEL_URL, {
    section: "releases",
    action: "get_cost",
    cost_split_id: cost_split_id
  }),
  submitCost:
    ({
      external_table,
      external_id,
      date,
      description,
      cost_group_id,
      currency,
      amount_orig_curr,
      exchange_rate,
      amount,
      payment_date,
      company,
      document_ref,
      cost_split_id
    },

    ) => MHTTPCL.post(LABEL_URL, {
      external_table: external_table,
      external_id: external_id,
      date: date,
      description: description,
      cost_group_id: cost_group_id,
      currency: currency,
      amount_orig_curr: amount_orig_curr,
      exchange_rate: exchange_rate,
      amount: amount,
      payment_date: payment_date,
      company: company,
      document_ref: document_ref,
      cost_split_id: cost_split_id,
      section: "releases",
      action: "submit_cost"

    }),

  changeIgnore: (cost_split_id, hold_flag) => MHTTPCL.post(LABEL_URL, {
    section: "royalty",
    action: "change_ignore",
    cost_split_id: cost_split_id,
    hold_flag: hold_flag
  }),

  autoFetchForAllContracts: () => MHTTPCL.post(LABEL_URL, {
    section: "royalty",
    action: "auto_fetch_for_all_contracts"
  }),


  accountAllRecoupablesV2: (
    {
      action = "account_all_recoupables",
      start_date = "",
      end_date = "",
      royalty_account_id = "",
      royalty_period = "",
      cost_groups = [],
      all_groups_selected = 0,
      label_id = "",
      release_id = "",
      invoice_id = "",
      status = [],
      balance_date = "",
      id_prod = "",
      company_code = "",
      validation = "",
      release_identifier = "",
      deal_type_ids = ""
    }
  ) => MHTTPCL.post(LABEL_URL, {
    start_date: start_date,
    end_date: end_date,
    royalty_account_id: royalty_account_id,
    royalty_period: royalty_period,
    cost_groups: JSON.stringify(cost_groups),
    all_groups_selected: all_groups_selected,
    label_id: label_id,
    release_id: release_id,
    invoice_id: invoice_id,
    status: JSON.stringify(["account_recoupable"]),
    balance_date: balance_date,
    id_prod: id_prod,
    company_code: company_code,
    validation: validation,
    release_identifier: release_identifier,
    deal_type_ids: deal_type_ids,
    section: "royalty",
    action: action
  }, {
    subdomain: 'batch',
  }),
  createCostSplit: (cost_split_id) => MHTTPCL.post(LABEL_URL, {
    section: "common",
    action: "create_cost_split",
    cost_split_id: cost_split_id,
    output: JSON_STRING
  })













  //recoupables_xlsx_export  





}



// start_date	"2021-07-01"
// end_date	"2021-07-02"       
// royalty_account_id	""
// royalty_period	""
// all_groups_selected	"0"
// label_id	""
// release_id	""
// invoice_id	""
// balance_date	""
// id_prod	""
// company_code	""
// validation	""
// release_identifier	""
// deal_type_ids	""
// section	"royalty"
// action	"filter_costs_v2"

// start_date	"2016-07-03"
// end_date	"2021-07-01"
// royalty_account_id	""
// royalty_period	""
// cost_groups	"[]"
// all_groups_selected	"0"
// label_id	""
// release_id	""
// invoice_id	""
// status	"[]"
// balance_date	""
// id_prod	""
// company_code	""
// validation	""
// release_identifier	""
// deal_type_ids	"[]"
// section	"royalty"
// action	"filter_costs_v2"




